import {ReactNode, createContext, useState} from "react";
import { GeneralObject } from "../types/General";
import { removeReference } from "../helpers/JavascriptHelpers";
import { CustomNotification } from "../components/notification/NotificationContainer";
import NotificationContainer from "../components/notification/NotificationContainer";
import { createPortal } from "react-dom";

type NotificationContextProviderProps = {
    children: ReactNode;
}

const NotificationContext = createContext({
    notifications: {} as GeneralObject<CustomNotification>,
    addNotification: (newNotification: CustomNotification) => {},
    removeNotification: (id: string) => {}
});

export function NotificationContextProvider({ children }: NotificationContextProviderProps) {
    const [notifications, setNotifications] = useState<GeneralObject<CustomNotification>>({})

    function addNotification(newNotification: CustomNotification) {
        if (newNotification.timeout !== -1)
            setTimeout(() => removeNotification(newNotification.id || 'temp'), newNotification.timeout || 3000)

        const newNotifications = {...notifications};
        newNotifications[newNotification.id || 'temp'] = newNotification;

        setNotifications(newNotifications)
    }

    function removeNotification(id: string) {
        const newNotifications = {...notifications};
        delete newNotifications[id];
        setNotifications(newNotifications);
    }

    const context = {
        notifications,
        addNotification,
        removeNotification
    };

    return (
        <NotificationContext.Provider value={context}>
            {createPortal(
                <NotificationContainer notifications={notifications} onDismiss={removeNotification}/>
            , document.getElementById('portal') as HTMLElement)}

            {children}
        </NotificationContext.Provider>
    )
}

export default NotificationContext;